import type {ISbStoryData} from "storyblok-js-client";
import type {AsyncData} from "nuxt/app";
import {type ReffedParameters, unrefParameters} from "../helpers/storyblok";
import {useAsyncDataWithPausing} from "./use-async-data-with-pausing";

import type {Ref} from "vue";
import {isRef} from "vue";
import {useRuntimeConfig} from "nuxt/app";
import {useStoryblokApi} from "@storyblok/vue";

// NOTE: Also see `useStoryblokStory` and `useStoryblokStories`

// This was impossible to find the proper type for here through nuxt's `AsyncDataOptions` type, so just manually pick the stuff we want to support here. Maybe casting the return values would have worked.
export type AsyncOptions = {
	lazy?: boolean;
	server?: boolean;
	deep?: boolean;
	immediate?: boolean;
	dedupe?: "cancel" | "defer";
	// default?: () => ISbStoryData[]
	pause?: Ref<boolean> | boolean;
};

export function useStoryblokStoriesList(
	fetchKey: string,
	parameters: ReffedParameters,
	asyncOptions: AsyncOptions = {},
): AsyncData<ISbStoryData[], unknown> {
	const api = useStoryblokApi();

	const watchValues = Object.values(parameters).filter((value) => isRef(value));

	return useAsyncDataWithPausing(
		fetchKey,
		async () => {
			try {
				const storiesRes = await api.getStories({
					resolve_links: "url",
					...unrefParameters(parameters),
					version:
						useRuntimeConfig().public.storyblokVersion === "published"
							? "published"
							: "draft",
				});

				return storiesRes.data.stories;
			} catch (error) {
				// eslint-disable-next-line no-console
				console.warn(error);

				return [];
			}
		},
		{
			watch: watchValues,
			...asyncOptions,
		},
	);
}
